import { configureRequest } from '../../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CreateDiscountCodeForAdminErrorResponse,
  CreateDiscountCodeForAdminRequest,
  CreateDiscountCodeForAdminSuccessResponse
} from './createDiscountCodeForAdmin.types'

export const createDiscountCodeForAdminApi = async (
  request: CreateDiscountCodeForAdminRequest
): Promise<CreateDiscountCodeForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.createDiscountCodeForAdmin,
    method: 'POST',
    data: request,
    params: {},
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CreateDiscountCodeForAdminSuccessResponse
  } else {
    throw response as CreateDiscountCodeForAdminErrorResponse
  }
}

export default createDiscountCodeForAdminApi
